import * as React from 'react';
import {connect} from 'react-redux';

import type {TimeseriesReportData} from 'nutshell-core/types';

import {ReportProviderContext} from '../../../reports/report-provider-context';

import type {NutshellState} from '../../../../store';

import {
    getCurrentReportChartIsLoading,
    getCurrentReportChartData,
    isChartTimedOut,
    isChartErrored,
} from '../editions-selectors';

type OwnProps = {
    children: React.ReactNode;
};

type StateProps = {
    isLoading: boolean;
    isTimedOut: boolean;
    isErrored: boolean;
    chartData: TimeseriesReportData | null | undefined;
};

type Props = OwnProps & StateProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        chartData: getCurrentReportChartData(state),
        isLoading: getCurrentReportChartIsLoading(state),
        isTimedOut: isChartTimedOut(state),
        isErrored: isChartErrored(state),
    };
}

class EditionEngagementReportProviderComponent extends React.Component<Props> {
    render() {
        const {chartData, isLoading, isTimedOut, isErrored} = this.props;

        return (
            // @ts-expect-error
            <ReportProviderContext.Provider value={{chartData, isLoading, isTimedOut, isErrored}}>
                {this.props.children}
            </ReportProviderContext.Provider>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);

export const EditionEngagementReportProvider = connector(EditionEngagementReportProviderComponent);
